// src/api/security.ts
import { api } from "./index";
import type { AxiosResponse } from "axios";
import type {
  DeviceUser,
  UserDevice,
  SecurityQueryParams,
} from "@/types/security";

/**
 * 获取设备上登录的用户列表
 * @param fingerprint 设备指纹
 * @param params 查询参数（可选的日期范围）
 * @returns 设备用户列表
 */
export async function getDeviceUsers(
  fingerprint: string,
  params?: SecurityQueryParams,
): Promise<DeviceUser[]> {
  const response: AxiosResponse = await api.get("/deviceUsers/", {
    params: {
      fingerprint,
      ...params,
    },
  });
  return response.data;
}

/**
 * 获取用户登录过的设备列表
 * @param userId 用户ID
 * @param params 查询参数（可选的日期范围）
 * @returns 用户设备列表
 */
export async function getUserDevices(
  userId: string,
  params?: SecurityQueryParams,
): Promise<UserDevice[]> {
  const response: AxiosResponse = await api.get("/userDevices/", {
    params: {
      userId,
      ...params,
    },
  });
  return response.data;
}
